// let moment.js support the current language
import moment from 'moment';

moment.locale(document.documentElement.lang);
